import React from 'react'
import { Row } from 'react-bootstrap'
import ColItem from './colItem'
import globals from 'application/constants/globals'
import { IsSpecialEmployer } from 'application/helpers'

interface IInputProps {
  fbt: number
  lcda: number
  erShare: number
  erShare_isDisplayed: boolean
  gstOnECM: number
  gstOnECM_isDisplayed: boolean
  greenfleet: number
  erAdminFee: number
  id: string
  isExGST: boolean
}

const TaxImplicationsTable = (props: IInputProps) => (
  <Row>
    <ColItem
      icon={globals.isBrandMX ? 'LeaseFees' : 'IconDollar3'}
      id={`${props.id}-fbt`}
      title="FBT"
      value={props.fbt}
      tooltip={{
        text: 'Fringe Benefits Tax As your novated lease is a benefit your employer provides outside of your salary or wages, it’s subject to FBT. You may be able to offset any FBT liability by using the Employee Contribution Method.',
      }}
      isExGST={props.isExGST}
    />

    {props.gstOnECM_isDisplayed && (
      <ColItem
        icon={globals.isBrandMX ? 'LeaseFees' : 'IconDollar3'}
        id={`${props.id}-gstOnECM`}
        title="GST on ECM"
        value={props.gstOnECM}
        tooltip={{
          text: 'Because your post-tax contribution (ECM) goes towards running costs, GST is applied as a ‘consumer-based tax’. It’s calculated as a fraction of your ECM (1/11th) and comes out of your post-tax contribution.',
        }}
        isExGST={props.isExGST}
      />
    )}

    <ColItem
      icon={globals.isBrandMX ? 'LeaseFees' : 'IconDollar3'}
      iconSize={2.2}
      id={`${props.id}-lcda`}
      title="Luxury car depreciation allowance"
      value={props.lcda}
      tooltip={{
        text: 'If the amount you’re financing is greater than the Luxury Vehicle Limit set by the ATO, your employer can’t claim Income Tax Credits for the full amount of your Novated Lease. LCDA is paid to your employer to compensate them for the portion of your lease they can’t claim.',
      }}
      isExGST={props.isExGST}
    />

    <ColItem
      icon={globals.isBrandMX ? 'LeaseFees' : 'IconDollar3'}
      id={`${props.id}-greenfleet`}
      title="Greenfleet donation"
      value={props.greenfleet}
      tooltip={{
        text: 'An optional donation paid to Greenfleet to offset your carbon emissions by planting trees.',
      }}
      isExGST={props.isExGST}
    />

    {props.erShare_isDisplayed && (
      <ColItem
        icon={globals.isBrandMX ? 'LeaseFees' : 'IconDollar3'}
        id={`${props.id}-erShare`}
        title="Employer share of benefit"
        value={props.erShare}
        tooltip={{
          text: IsSpecialEmployer('NSWHN')
            ? 'As per NSW Health Policy, 50% of your novated lease tax benefit is shared with your organisation.'
            : 'A percentage of your novated lease benefit that is paid to your employer.',
        }}
        isExGST={props.isExGST}
      />
    )}

    <ColItem
      icon={globals.isBrandMX ? 'LeaseFees' : 'IconDollar3'}
      id={`${props.id}-erAdminFee`}
      title="Tax share"
      value={props.erAdminFee}
      tooltip={{
        text: 'The fee paid to your employer for administering your salary package',
      }}
      isExGST={props.isExGST}
    />
  </Row>
)

export default TaxImplicationsTable
